module.exports = __webpack_public_path__ + "static/media/Circo2025_03.c20e1903.webp";